export class BaseClass {
}
//# sourceMappingURL=base-class.js.map